import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import { Button, formatDate, Modal } from '@frontendmentorio/design-system-v2';

export default function ConfirmModal({ modal, startChallenge }) {
  const currentUser = useSelector(selectCurrentUser);

  const handleStartChallenge = () => {
    startChallenge();

    modal.close();
  };

  return (
    <Modal modal={modal}>
      <Modal.Heading>Just to confirm...</Modal.Heading>

      <div className="flex flex-col gap-3">
        <p>
          You've got{' '}
          <span className="font-bold">
            {currentUser.credits.premium} credits remaining.
          </span>{' '}
          After starting this challenge you’ll have{' '}
          <span className="font-bold">{currentUser.credits.premium - 1}</span>{' '}
          left.{' '}
          {currentUser.subscription?.nextPaymentAt && (
            <>
              You will receive more credits on{' '}
              <span className="font-bold">
                {formatDate(currentUser.subscription.nextPaymentAt)}
              </span>
              .
            </>
          )}
        </p>

        {currentUser.subscription?.status === 'active' && (
          <p>
            If you'd like unlimited credits, you can switch to our yearly plan
            by contacting us at{' '}
            <a
              className="underline hover:no-underline"
              href="mailto:hi@frontendmentor.io"
            >
              hi@frontendmentor.io
            </a>
            .
          </p>
        )}
      </div>

      <div className="flex gap-3 justify-end">
        <Button isGhost level="secondary" onClick={modal.close}>
          Cancel
        </Button>

        <Button onClick={handleStartChallenge}>Accept and continue</Button>
      </div>
    </Modal>
  );
}
